import { TriangleAlert } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { messages } from '@/i18n';
import { INPUT_CLASS } from './mfaUtils';

export function ErrorAlert({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <Alert variant="destructive">
      <TriangleAlert aria-hidden />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}

/**
 * The 6-digit code field shared by every challenge and enrollment step.
 * Submitting is always an explicit button press: nothing auto-submits on the
 * sixth digit.
 */
export function CodeField({
  value,
  onChange,
  disabled,
  label = messages.mfa.codeLabel,
}: {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <label className="flex flex-col gap-1 text-sm">
      {label}
      <input
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="[0-9]*"
        maxLength={6}
        required
        className={`${INPUT_CLASS} font-mono tracking-[0.3em]`}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
        disabled={disabled}
      />
    </label>
  );
}
